module.exports = __webpack_public_path__ + "img/LoadingThumbnail.d7d96722.png";